import { FunctionComponent } from 'react';
import styled from 'styled-components';

import HeaderCaret from '@/components/atom/icon/Arrow/HeaderCaret';
import { zIndex } from '@/constants/zIndex';
import { historyBack } from '@/utils/mobile/RNPlugins';

import SearchInput, { SearchInputProps } from './SearchInput';

interface HeaderSearchBarProps extends SearchInputProps {
  isFixed?: boolean;
  isMobileWeb?: boolean;
}

const HeaderSearchBar: FunctionComponent<HeaderSearchBarProps> = ({ isFixed, isMobileWeb, ...props }) => {
  return (
    <SearchBarWrapper id={'appHeader'} isFixed={isFixed} isMobileWeb={isMobileWeb}>
      <ArrowWrapper onClick={historyBack}>
        <HeaderCaret />
      </ArrowWrapper>
      <SearchInput {...props} />
    </SearchBarWrapper>
  );
};

export default HeaderSearchBar;

export const SearchBarWrapper = styled.div<{
  isFixed?: boolean;
  isMobileWeb?: boolean;
}>`
  ${({ theme, isMobileWeb }) => `
    height: ${theme.size.appHeader.height};
    top: ${isMobileWeb ? theme.size.mobileWebHeader.height : 0}px;
    background: ${theme.color.white};
    `};
  position: sticky;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 6px 24px 6px 16px;
  z-index: ${zIndex.AppHeader};
`;

export const ArrowWrapper = styled.button`
  padding: 6px;
  border: none;
  border-radius: 4px;

  &:active {
    background-color: ${({ theme }) => theme.color.gray50};
  }
`;
